export default {"src":"/_next/static/media/modarnaBackgroundVector.7b0a5be0.svg","height":998,"width":912,"blurWidth":0,"blurHeight":0};